<div [formGroup]="form">
  <fieldset>
    <legend class="font-size-normal label margin-bottom-xs text-nowrap" [ngClass]="{ required: required }">
      {{ context.label | translate }}
      @if (required) {
        <span class="color-error">*</span>
      }
    </legend>
    <div [id]="context.field" class="common-checkbox-controls">
      @for (value of selectValues; track value) {
        <app-common-checkbox
          [disabled]="disabled"
          [ngModel]="isSelected(value)"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="valueChanged(value, $event)"
        >
          <span class="checkbox-label">
            @if (context.translateName) {
              {{ getOptionName(value) | translate }}
            }
            @if (!context.translateName) {
              {{ getOptionName(value) }}
            }
          </span>
        </app-common-checkbox>
      }
    </div>
    <div [id]="context.field + '-error'" class="error-container">
      <app-form-field-error
        [formValidationRequest$]="formValidationRequest$"
        [field]="form.get(context.field)"
        [name]="context.field"
        [label]="context.label"
      ></app-form-field-error>
    </div>
  </fieldset>
</div>
